import { gql } from '@apollo/client'
import creditCardType, { CreditCardTypeInfo } from 'credit-card-type'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { PaymentToken } from 'lib/core/data/customer/paymentTokens/types'

export const payeezyClientToken = gql`
  {
    payeezyClientToken {
      clientToken
      error
      message
      publicKeyBase64
    }
  }
`

export const payeezyPaymentTokenList = gql`
  {
    payeezyPaymentTokenList {
      entity_id
      cc_type
      cc_last_4
      cc_exp_month
      cc_exp_year
      cc_cardholder_name
      is_default
      public_hash
    }
  }
`

export const payeezyPaymentTokenCreate = gql`
  mutation payeezyPaymentTokenCreate(
    $clientToken: String!
  ) {
    payeezyPaymentTokenCreate(client_token: $clientToken) {
      cc_cardholder_name
      cc_exp_month
      cc_exp_year
      cc_last_4
      cc_type
      entity_id
      is_default
    }
  }
`

export const payeezyPaymentTokenSave = gql`
  mutation payeezyPaymentTokenSave(
    $entityId: Int!
    $isDefault: Boolean!
  ) {
    payeezyPaymentTokenSave(
      input: {
        entity_id: $entityId,
        is_default: $isDefault
      }
    ) {
      entity_id
    }
  }
`

export const payeezyPaymentTokenDelete = gql`
  mutation payeezyPaymentTokenSave(
    $entityId: Int!
  ) {
    payeezyPaymentTokenDelete(
      entity_id: $entityId,
    ) {
      success
      message
    }
  }
`

export interface PayeezyClientTokenOut {
  clientToken: string
  error: boolean
  message: string
  publicKeyBase64: string
}

export interface PayeezyPaymentToken {
  cc_cardholder_name: string
  cc_exp_month: string
  cc_exp_year: string
  cc_last_4: string
  cc_type: string
  entity_id: number
  is_default: boolean
  public_hash: string
}

export interface PayeezyPaymentTokenDeleteOut {
  message: String
  success: Boolean
}

export interface SetVaultPaymentMethodOnCartResponse {
  setPaymentMethodOnCart: {
    cart: {
      selected_payment_method: {
        code: string
      }
    }
  }
}

export const setVaultPaymentMethodOnCartMutation = gql`
  mutation setPaymentMethodOnCart(
    $cartId: String!
    $publicHash: String!
  ) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId,
        payment_method: {
          code: "${PAYMENT_METHOD.PAYEEZY_VAULT}"
          payeezy_cc_vault: {
            public_hash: $publicHash
          }
        }
      }
    ) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
  }
`

export interface PayeezyCreditCardMeta {
  creditCardInfo: CreditCardTypeInfo
  last4: string
  expiration: string
  holderName: string
}

export const parseCreditCardDetails = (paymentMethod: PaymentToken): PayeezyCreditCardMeta => {
  const { details } = paymentMethod
  const creditCardInfo = creditCardType.getTypeInfo(details.ccType)
  const last4 = (details.ccMasked ?? '').slice(-4)
  const expiration = `${(details.ccExpDate ?? '').slice(0, 2)}/${(details.ccExpDate ?? '').slice(-2)}`

  return {
    creditCardInfo,
    last4,
    expiration,
    holderName: details.ccCardholderName
  }
}
